// Centralized i18n Configuration for LocalCraft Israel
// Single source of truth for all language-related settings

export const SUPPORTED_LANGUAGES = [
  {
    code: 'en',
    label: 'English',
    dir: 'ltr',
    hreflang: 'en',
    ogLocale: 'en_US',
  },
  {
    code: 'he',
    label: 'עברית',
    dir: 'rtl',
    hreflang: 'he',
    ogLocale: 'he_IL',
  },
  {
    code: 'ru',
    label: 'Русский',
    dir: 'ltr',
    hreflang: 'ru',
    ogLocale: 'ru_RU',
  },
  {
    code: 'es',
    label: 'Español',
    dir: 'ltr',
    hreflang: 'es',
    ogLocale: 'es_ES',
  },
] as const;

export type SupportedLanguageCode = 'en' | 'he' | 'ru' | 'es';

export const DEFAULT_LANGUAGE: SupportedLanguageCode = 'en';

/**
 * Get language config by code
 */
export function getLanguageConfig(code: string) {
  return SUPPORTED_LANGUAGES.find(lang => lang.code === code) || SUPPORTED_LANGUAGES[0];
}

/**
 * Get direction (ltr/rtl) for a language
 */
export function getLanguageDir(code: string): 'ltr' | 'rtl' {
  const config = getLanguageConfig(code);
  return config.dir;
}

/**
 * Get OG locale code for a language
 */
export function getOgLocale(code: string): string {
  const config = getLanguageConfig(code);
  return config.ogLocale;
}

/**
 * Get hreflang code for a language
 */
export function getHreflangCode(code: string): string {
  const config = getLanguageConfig(code);
  return config.hreflang;
}

/**
 * Validate if a language code is supported
 */
export function isSupportedLanguage(code: string): code is SupportedLanguageCode {
  return SUPPORTED_LANGUAGES.some(lang => lang.code === code);
}
